import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const TotalPriceFieldContainer: React.VFC = () => {
  const { price, published } = useOfferContext();

  const totalPrice = price && price.total;

  if (totalPrice) {
    return <TextField published={published}>{totalPrice}</TextField>;
  }

  return <EmptyField published={published} />;
};
